module.exports = __webpack_public_path__ + "img/Defect.33d84cbd.png";